/* eslint-disable react/function-component-definition */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import ParseContent from 'components/shared/ParseContent'
import HeroAlt from 'components/elements/HeroAlt'

const Content = styled.div`
  & h2 {
    font-size: ${(props) => props.theme.font.size.xl};
  }

  & ol > li > ol {
    list-style: lower-latin;
  }
`

export const pageQuery = graphql`
  query ($id: String) {
    page: wpPage(id: { eq: $id }) {
      title
      uri
      content
      pageDefault {
        headerdefault {
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }
      }
      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublisher
        opengraphPublishedTime
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          sourceUrl
        }
        twitterImage {
          sourceUrl
        }
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { title, content, pageDefault, seo },
  },
}) => (
  <Layout subFooter>
    <SEO seo={seo} />
    <HeroAlt src={pageDefault.headerdefault.image} small>
      BAANBREKEND BOUWEN
    </HeroAlt>
    <section>
      <div className="container">
        <div className="row py-5">
          <div className="col-lg-2" />
          <div className="col-lg-8 py-3">
            <h2 className="text-center">{title}</h2>
            <Content className="text-justify">
              <ParseContent content={content} />
            </Content>
          </div>
          <div className="col-lg-2" />
        </div>
      </div>
    </section>
  </Layout>
)

export default PageTemplate
